import React, { FunctionComponent } from 'react';
import { TicketContentProps, TicketFeeTaxDescription } from '../TicketContent';
import './TicketDonationFeeTaxDescription.scss';

export interface TicketDonationFeeTaxDescriptionProps
    extends Pick<TicketContentProps, 'category' | 'includeFee' | 'includeTax'> {
    canBeSelected: boolean;
    separatorCharacter: string;
}

export const TicketDonationFeeTaxDescription: FunctionComponent<
    TicketDonationFeeTaxDescriptionProps
> = ({
    canBeSelected,
    category,
    includeFee,
    includeTax,
    separatorCharacter,
}) => {
    const donationText = TicketFeeTaxDescription({
        canBeSelected,
        category,
        includeFee,
        includeTax,
    });

    if (donationText === null) return null;
    return (
        <span
            className="ticket-donation-fee-tax-description eds-text-color--ui-800"
            data-testid="ticket-donation-fee-tax-description"
        >
            {separatorCharacter}
            {donationText}
        </span>
    );
};
export default TicketDonationFeeTaxDescription;
